import { useMemo } from 'react';
import { useQuery } from '@apollo/client/react';
import get from 'lodash/get';
import { COUNT_TABLE_RECORDS } from 'constants/constants';
import settings from 'config/settings';
import { AllProjectsDocument, type AllProjectsQuery } from 'graphql/generated/graphql';
import type { TListItem } from 'graphql/types';

const { rootUrl } = settings;

/** The projects of a page (the schema allows a null list and null items). */
export type TProjects = NonNullable<AllProjectsQuery['allProjects']>['filteredProjects'];

export type TProject = TListItem<TProjects>;

const useGetProjects = ({ currentPage, filter }: { currentPage: number; filter: string }) => {
  const offset = COUNT_TABLE_RECORDS * (currentPage - 1);

  const { data, loading } = useQuery(AllProjectsDocument, {
    variables: { rootUrl, filter, offset, limit: COUNT_TABLE_RECORDS },
  });

  const projects = useMemo(() => {
    const noProjects: TProjects = [];
    return get(data, 'allProjects.filteredProjects', noProjects);
  }, [data]);
  const total = get(data, 'allProjects.count', 0);

  return { projects, total, loading };
};

export default useGetProjects;
